import React, { useEffect, useRef } from 'react'
import { useTheme } from '../Context/ThemeContext'

function ColorsList() {

    const ref = useRef(null);

    const { theme, chooseColor, setChooseColor, colors, selectedColor, handleColorChange } = useTheme();

    useEffect(() => {

        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target) && !event.target.classList.contains('choose-color')) {
                setChooseColor(false);
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };

    }, [chooseColor, setChooseColor]);

    return (
        <div ref={ref} style={{ transition: "all 1s ease", transform: `${chooseColor ? "scaleY(1)" : "scaley(0)"}` }} className={`${chooseColor ? "h-auto" : "h-0"} transition-all pt-5 flex items-center justify-center ease-in-out duration-300`}>
            {Object.entries(colors[theme].colors).map((color, index) => (
                <div key={index} className="flex flex-wrap">
                    {(typeof color === 'object') && (
                        <div className={`flex cursor-pointer mx-2 p-1 ${color[0] === selectedColor ? "border-2 border-gray-500 rounded-md" : ""}`} onClick={() => {
                            handleColorChange(color[0])
                        }}>
                            <div className={`${color[1].bgPrimary} p-5 rounded-l-md`}></div>
                            <div className={`${color[1].bgSecondary} p-5 rounded-r-md`}></div>
                        </div>
                    )}
                </div>
            ))
            }
        </div >
    )
}

export default ColorsList